import React from 'react';

import DocumentRequestTop from 'sections/documentRequest/DocumentRequestTop';
import { SEO, buildBreadcrumb } from 'hooks/useSeo';
import { PageUrl } from 'const/page-url';

// ==============================|| DOCUMENT REQUEST PAGE ||============================== //
//
// 資料請求の専用ページ。トップページのバナーおよび各所のCTAからここへ遷移する。
// 入力フォームを1画面に絞り、他の情報を置かないことで離脱を減らす狙い。

const DocumentRequest: React.FC = () => {
    return (
        <React.Fragment>
            <SEO
                title="資料請求 | サービス紹介資料を無料ダウンロード | OHANA AI"
                description="児童発達支援・放課後等デイサービス向けAI「OHANA AI」のサービス紹介資料を無料でお配りしています。AIアセスメントと個別支援計画書の自動作成、専門的支援加算の増収シミュレーション、減算対策、料金と導入の流れを収録。ご入力後、その場でPDFをダウンロードいただけます。"
                path={PageUrl.DocumentRequest.urlWithSlash}
                jsonLd={buildBreadcrumb([{ name: '資料請求', path: PageUrl.DocumentRequest.urlWithSlash }])}
            />
            <DocumentRequestTop />
        </React.Fragment>
    );
};

export default DocumentRequest;
